import { Chip, Grid, Paper } from '@material-ui/core';
import {
  DateRangeRounded as DateRange,
  DescriptionRounded as Description,
  LocationOnRounded as LocationOnIcon,
  SchoolRounded as SchoolIcon,
} from '@material-ui/icons';
import { addViewOffer } from '@webapps/business';
import {
  Button,
  ModalSideBar,
  useMutation,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import HourglassHalf from 'components/Icons/HourglassHalf';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import theme from '../../theme';
import DetailsAnnonce from 'components/DetailsAnnonce';

const CardOffer = ({
  address,
  contrat,
  item,
  lastTimeView,
  name,
  typeFormation,
}) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const [viewOffre, setViewOffre] = useState(false);

  const { mutateAsync: mutateAddView } = useMutation(addViewOffer);

  useEffect(() => {
    if (viewOffre && item?.id) {
      mutateAddView({
        id: item?.id,
      });
    }
  }, [viewOffre]);

  const handleClose = () => {
    setViewOffre(false);
  }

  const handleOpen = () => {
    if (!viewOffre) {
      setViewOffre(true);
    }
  };

  return (
    <>
      <div className={classes.paper} onClick={handleOpen}>
        <div className={classes.items}>
          <h1 className={cx(classes.title, global.title, global.ellipsis90)}>{name.label}</h1>
          <div className={classes.cardContainer}>
            <div className={classes.cardItem}>
              <LocationOnIcon className={global.infoIcon} />
              <p style={{ margin: 0 }} className={cx(global.infoText, global.ellipsis85)}>
                {address.cityCode} {address.city}
              </p>
            </div>
            <div className={classes.cardItem}>
              <Description className={global.infoIcon} />
              <p style={{ margin: 0 }} className={cx(global.infoText, global.ellipsis85)}>{contrat.label}</p>
            </div>
          </div>
          <div className={classes.cardContainer}>
            <div className={classes.cardItem}>
              <HourglassHalf className={global.infoIcon} />
              <p style={{ margin: 0 }} className={cx(global.infoText, global.ellipsis85)}> {item.contractLength} mois de contrat</p>
            </div>
            <div className={classes.cardItem}>
              <SchoolIcon className={global.infoIcon} />
              <p style={{ margin: 0 }} className={cx(global.infoText, global.ellipsis85)}>{typeFormation.label}</p>
            </div>
          </div>
        </div>
      </div>
      <ModalSideBar
        handleClose={handleClose}
        open={viewOffre}
        title={name?.label}
      >
        <DetailsAnnonce info={item} />
      </ModalSideBar>
    </>
  );
};

const styles = ({ spacing }) => ({
  paper: {
    padding: '20px',
    borderRadius: 10,
    width: '49%',
    height: '100%',
    display: 'flex',
    backgroundColor: 'white',
    flexDirection: 'column',
    border: '1px solid #C0D9FF',
    transition: 'all 0.2s',
    '&:hover': {
      transition: 'all 0.2s',
      border: '1px solid #0060F9',
      'h1': {
        transition: 'all 0.2s',
        color: '#0060F9',
      },
      'p': {
        transition: 'all 0.2s',
        color: '#152652',
      },
      'svg': {
        transition: 'all 0.2s',
        color: '#0060F9',
      }
    },
    cursor: 'pointer',
    '@media (max-width:1520px)': { width: '48.7%' },
    '@media (max-width:1280px)': { width: '100%' },
  },
  title: {
    marginBottom: '10px',
    marginTop: 0,
    transition: 'all 0.2s',
  },
  cardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  cardItem: {
    display: 'flex',
    width: '50%',
    alignItems: 'center',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
  },
  items: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '10px',
  },
});

CardOffer.propTypes = {
  address: PropTypes.object,
  contrat: PropTypes.object,
  lastTimeView: PropTypes.string,
  name: PropTypes.object,
  typeFormation: PropTypes.object,
  item: PropTypes.object,
};

export default CardOffer;
